export default __webpack_public_path__ + "static/media/tn.26558584.jpg";